import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { select } from '@rematch/select'

import {
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input
} from 'reactstrap'
import PageTitle from 'components/PageTitle'
import View from 'components/View'

import ImportList from './components/ImportList'

import ImportDetail from './ImportDetail'
import Roles from 'features/auth/Roles'

function isNumeric(str) {
    if (typeof str != 'string') {
        return false
    } // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

class ImportIndex extends React.Component {
    static propTypes = {
        data: PropTypes.array,
        select: PropTypes.func,
        deselect: PropTypes.func,
        selected: PropTypes.object,
        filter: PropTypes.func,
        nameFilter: PropTypes.string,
        roles: PropTypes.array,
        organisatieId: PropTypes.number
    }

    static defaultProps = {
        data: [],
        select: () => { },
        selected: {},
        filter: () => { },
        nameFilter: ''
    }

    handleFilterChanged = name => {
        this.props.filter(name)
    }

    handleSelectOrganisatie = e => {
        this.props.select(e.target.value)
    }

    renderDataView = data => {
        if (data.length === 0) {
            return <div className="pl-3">Geen organisaties gevonden.</div>
        }

        return (
            <ImportList
                data={ data }
                onSelect={ this.handleSelectOrganisatie }
                selected={ this.props.selected }
            />
        )
    }

    render() {
        const { roles, organisatieId } = this.props

        if (
            !this.props.selected &&
            roles &&
            roles.indexOf(Roles.SuperAdmin) < 0 &&
            isNumeric(organisatieId) &&
            organisatieId > 0
        ) {
            this.handleSelectOrganisatie(organisatieId)
        }

        return (
            <View className="ao-route ao-route__importindex">
                <div className="ao-dashboard">
                    <Container>
                        <Row>
                            <PageTitle>Organisaties importeren</PageTitle>
                        </Row>
                        <Row className="ao-export-filter">
                            <Col md={ 6 }>
                                <FormGroup>
                                    <Label for="organisation">Organisatie</Label>
                                    <Input
                                        type="select"
                                        name="organisation"
                                        onChange={ this.handleSelectOrganisatie }
                                    >
                                        <option value="" />
                                        { this.props.data.map(option => (
                                            <option
                                                key={ `organisation-option-${option.id}` }
                                                value={ option.id }
                                            >
                                                { option.organisatieNaam } ({ option.id })
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={ 6 }/>
                        </Row>
                        <ImportDetail organisatie={ this.props.selected } />
                    </Container>
                </div>
            </View>
        )
    }
}

function mapStateToProps(state) {
    return {
        data: select.organisations.list(state),
        selected: select.organisations.selected(state),
        nameFilter: select.organisations.nameFilter(state),
        roles: select.profile.roles(state),
        organisatieId: select.profile.organisationId(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        select: dispatch.organisations.select,
        deselect: dispatch.organisations.deselect,
        filter: dispatch.organisations.filter
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportIndex)
